import React, { useState, useEffect }  from 'react';
import axios from 'axios';

// Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css';
//
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
// Datetime picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from 'react-bootstrap/Table'
// Generación Excel
import * as XLSX from 'xlsx';

const ReportesFinanzas = ({usuario, apiUrl}) => {
    // Filtros
    const [tipoReporte, setTipoReporte] = useState("proyecto");
    const [proyectoSelected, setProyectoSelected] = useState(0);
    const [departamentoSelected, setDepartamentoSelected] = useState(0);
    const [estatusSupervisorSelected, setEstatusSupervisorSelected] = useState(0);
    const [estatusJefeSelected, setEstatusJefeSelected] = useState(0);
    const dateFechaInicial = new Date();
    dateFechaInicial.setHours(0, 0, 0, 0);
    const dateFechaFinal = new Date();
    dateFechaFinal.setHours(23, 59, 59, 999);
    const [fechaInicioSelected, setFechaInicioSelected] = useState(dateFechaInicial);
    const [fechaFinSelected, setFechaFinSelected] = useState(dateFechaFinal);
    //
    const [proyectos, setProyectos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);

    const exportarDatos = (datos) => {
        if (datos.length === 0) {
            alert('Tu consulta no retornó registros.')
        }
        else {
            const ws = XLSX.utils.json_to_sheet(datos);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, `costo por ${tipoReporte}.xlsx`);
            XLSX.writeFile(wb, `Reporte costo por ${tipoReporte}.xlsx`);
        }
    }
    
    const exportarReporte = () => {
        switch(tipoReporte)
        {
            case 'proyecto':
                axios.post(`${apiUrl}/proyecto/reporteCostoProyecto?token=${sessionStorage.getItem('token')}`, 
                    {
                        idProyecto: proyectoSelected,
                        estatusSupervisor: estatusSupervisorSelected,
                        estatusJefe: estatusJefeSelected,
                        fechaInicio: fechaInicioSelected,
                        fechaFin: fechaFinSelected,
                        idPerfil: usuario.idPerfil
                    })
                    .then((objResponse) => {
                        exportarDatos(objResponse.data.response);
                    })
                    .catch((error) => {
                        alert('hubo un error al recuperar las horas de los proyectos: ' + error.response.data)
                    });
                break;
            case 'departamento':
                axios.post(`${apiUrl}/departamento/reporteCostoDepartamento?token=${sessionStorage.getItem('token')}`, 
                    {
                        idDepto: departamentoSelected,
                        estatusSupervisor: estatusSupervisorSelected,
                        estatusJefe: estatusJefeSelected,
                        fechaInicio: fechaInicioSelected,
                        fechaFin: fechaFinSelected,
                        idPerfil: usuario.idPerfil
                    })
                    .then((objResponse) => {
                        exportarDatos(objResponse.data.response);
                    })
                    .catch((error) => {
                        alert('hubo un error al recuperar las horas de los departamentos: ' + error.response.data)
                    });
                break;
            default:
                alert("Escoge un tipo de reporte por favor");
        }
    }

   const obtenerProyectos = ()=>{
        axios
            .post(`${apiUrl}/proyecto/obtenProyectos?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setProyectos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error al recuperar todos los proyectos: ' + error.response.data)
            });
    }

    const obtenerDepartamentos = () => {
        axios.post(`${apiUrl}/departamento/obtenDepartamentos?token=${sessionStorage.getItem('token')}`)
            .then((objResponse) => {
                setDepartamentos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error al recuperar los departamentos: ' + error.response.data)
            });
    }

    useEffect(() => {
        obtenerProyectos();
        obtenerDepartamentos();
    }, [])

    return (
        <div>
            <Container style={{marginTop: '1em'}}>
                <Row>
                    <Col><h3 style={{textAlign: 'center'}}>Generación de reportes</h3></Col>
                </Row>
                <Row className="justify-content-md-center" >
                    <Col md={8}>
                        <Table striped hover>
                            <tbody>
                                
                                <tr>
                                    <td>
                                        <label>Seleccionar proyecto: </label>
                                    </td>
                                    <td colSpan={2}>
                                        {
                                            (tipoReporte==='proyecto') ?
                                                <Form.Select
                                                    onChange={event => { setProyectoSelected(event.target.value) }}
                                                >
                                                    <option key="opt_proyecto0" value={0}>Todos los proyectos</option>
                                                    {
                                                        proyectos.map(proyecto =>
                                                            <option 
                                                                key={'opt_proyecto'+proyecto.IDPROYECTO}
                                                                value={proyecto.IDPROYECTO}
                                                            >
                                                                {proyecto.NOMBREPROYECTO}
                                                            </option>
                                                        )
                                                    }
                                                </Form.Select>
                                            : 
                                                <Form.Select
                                                    onChange={event => { setDepartamentoSelected(event.target.value) }}
                                                >
                                                    <option key="opt_departamento0" value={0}>Todos los departamentos</option>
                                                    {
                                                        departamentos.map(departamento =>
                                                            <option 
                                                                key={'opt_departamento'+departamento.IDDEPTO} 
                                                                value={departamento.IDDEPTO} 
                                                            >
                                                                {departamento.DEPTO}
                                                            </option>
                                                        )
                                                    }
                                                </Form.Select>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Estado horas supervisor: </label>
                                    </td>
                                    <td>
                                        <Form.Select 
                                            key={'select_estatus_supervisor'}
                                            onChange={(event)=>{ setEstatusSupervisorSelected(event.target.value) }}
                                        >
                                            <option key={'opt_supervisor_0'} value='0'>TODOS</option>
                                            <option key={'opt_supervisor_1'} value='PENDIENTE'>PENDIENTE</option>
                                            <option key={'opt_supervisor_2'} value='APROBADA'>APROBADA</option>
                                            <option key={'opt_supervisor_3'} value='RECHAZADA'>RECHAZADA</option>
                                        </Form.Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Estado horas jefe: </label>
                                    </td>
                                    <td>
                                        <Form.Select 
                                            key={'select_estatus_jefe'}
                                            onChange={(event)=>{ setEstatusJefeSelected(event.target.value) }}
                                        >
                                            <option key={'opt_jefe_0'} value='0'>TODOS</option>
                                            <option key={'opt_jefe_1'} value='PENDIENTE'>PENDIENTE</option>
                                            <option key={'opt_jefe_2'} value='APROBADA'>APROBADA</option>
                                            <option key={'opt_jefe_3'} value='RECHAZADA'>RECHAZADA</option>
                                        </Form.Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Fecha inicio: </label>
                                    </td>
                                    <td>
                                        <DatePicker className='form-control' dateFormat="dd/MM/yyyy" 
                                            selected={fechaInicioSelected} 
                                            onChange={(fechaInicio) => setFechaInicioSelected(fechaInicio)} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Fecha fin: </label>
                                    </td>
                                    <td>
                                        <DatePicker className='form-control' dateFormat="dd/MM/yyyy" 
                                            selected={fechaFinSelected} 
                                            onChange={(fechaFin) => setFechaFinSelected(fechaFin)} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                     
                                    </td>
                                    <td>
                                        <Button
                                            className='btn btn-success'
                                            variant="success"
                                            onClick={exportarReporte}
                                        >
                                            Exportar reporte
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ReportesFinanzas;